<span [class]="badgeClass()">{{ label() }}</span>
